import { Flex } from '@buffer-mono/popcorn'

import {
  CommentIcon,
  LikeIcon,
  RepostIcon,
  SendIcon,
} from '../../../../assets/linkedin'
import { CircleAvatar } from '../../../Common/components/CircleAvatar'
import { DEFAULT_AVATAR } from '../../../Common/utils'

import styles from './Post.module.css'

import type { JSX } from 'react'

export const LinkedInPostActions = ({
  avatar,
  username,
}: {
  avatar: string
  username: string
}): JSX.Element => {
  return (
    <Flex align="center" justify="between" className={styles.actions}>
      <Flex
        direction="column"
        align="center"
        gap="xs"
        className={styles.action}
      >
        <CircleAvatar
          src={avatar || DEFAULT_AVATAR}
          alt={username}
          size="small"
          className={styles.footerAvatar}
        />
      </Flex>
      <Flex
        direction="column"
        align="center"
        gap="xs"
        className={styles.action}
      >
        <LikeIcon size="small" color="currentColor" />
        Like
      </Flex>
      <Flex
        direction="column"
        align="center"
        gap="xs"
        className={styles.action}
      >
        <CommentIcon size="small" color="currentColor" />
        Comment
      </Flex>
      <Flex
        direction="column"
        align="center"
        gap="xs"
        className={styles.action}
      >
        <RepostIcon size="small" color="currentColor" />
        Repost
      </Flex>
      <Flex
        direction="column"
        align="center"
        gap="xs"
        className={styles.action}
      >
        <SendIcon size="small" color="currentColor" />
        Send
      </Flex>
    </Flex>
  )
}
